// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._11q7143w{background:var(--ds-surface-raised)}\n._189et94y{border-width:1px}\n._1bsb1osq{width:100%}\n._1dqonqa1{border-style:solid}\n._1h6dn5am{border-color:var(--ds-border)}\n._1ul9uuw1{min-width:200px}\n._2rkoi2wt{border-radius:6px}\n._4t3i1osq{height:100%}\n._vchhusvi{box-sizing:border-box}", ""]);
// Exports
module.exports = exports;
